import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: "",
  severity: "",
  open: false,
  loader: false,
  fromUserSaga: false,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state, action) => {
      state.open = true
      state.message = action.payload.message;
      state.severity = action.payload.severity;
      state.fromUserSaga = action.payload.fromUserSaga || false;
    },
    closeNotification: (state, action) => {
      state.open = false
    },
    setAppLoading: (state, action) => {
      state.loader = true
    },
    resetAppLoading: (state, action) => {
      state.loader = false
    }
  },
});

export const { setNotification, closeNotification, setAppLoading, resetAppLoading } = notificationSlice.actions;
export default notificationSlice.reducer;